import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app";
import Blog from "./pages/blog";
import { BrowserRouter, Route, Routes } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <BrowserRouter basename="/">
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/blog/:name" element={<Blog />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
